export default __webpack_public_path__ + "static/media/dtsd5168.5ea8c2fd.png";